<app-dropdown-autocomplete
    labelAlign="left"
    [formControl]="liftForm.controls.lift"
    [showErrors]="showValidations"
    [items]="lifts"
    [resetSelectionOnItemChange]="true"
    [label]="'admin.lifts.copyBatchesModal.labels.lift' | translate"
    [emptyText]="'admin.lifts.copyBatchesModal.placeholders.lift' | translate"
    (selectItem)="onSelectLift($event)"
    valueField="id"
></app-dropdown-autocomplete>

<app-dropdown-autocomplete
    *ngIf="selectedLift"
    labelAlign="left"
    [formControl]="trayForm.controls.tray"
    [showErrors]="showValidations"
    [items]="trays"
    [resetSelectionOnItemChange]="true"
    [label]="'admin.lifts.copyBatchesModal.labels.tray' | translate"
    [emptyText]="'admin.lifts.copyBatchesModal.placeholders.tray' | translate"
    (selectItem)="onSelectTray($event)"
    valueField="id"
></app-dropdown-autocomplete>

<app-dropdown-autocomplete
    *ngIf="selectedTray"
    labelAlign="left"
    [formControl]="slotForm.controls.slot"
    [showErrors]="showValidations"
    [items]="slots"
    [resetSelectionOnItemChange]="true"
    [label]="'admin.lifts.copyBatchesModal.labels.slot' | translate"
    [emptyText]="'admin.lifts.copyBatchesModal.placeholders.slot' | translate"
    (selectItem)="onSelectSlot($event)"
    valueField="id"
></app-dropdown-autocomplete>
